/**
 * Platform (super-admin) console navigation — used by vertical sidebar and horizontal layout.
 * Add entries here when you add new pages under src/pages/superadmin/.
 */

const normalizePath = pathname => (pathname || "").replace(/\/+$/, "") || "/"

/**
 * Exact sidebar child path to highlight (nested routes map to their section child).
 */
export function resolveSuperAdminMenuPath(pathname) {
  const normalized = normalizePath(pathname)
  if (!normalized || normalized === "/") return "/superadmin/dashboard"
  if (normalized.startsWith("/superadmin/dashboard")) return "/superadmin/dashboard"
  if (normalized.startsWith("/superadmin/plans")) return "/superadmin/plans"
  if (normalized.startsWith("/superadmin/billing/subscriptions")) {
    return "/superadmin/billing/subscriptions"
  }
  if (normalized.startsWith("/superadmin/billing/invoices")) {
    return "/superadmin/billing/invoices"
  }
  if (normalized.startsWith("/superadmin/integrations")) {
    return "/superadmin/integrations"
  }
  if (normalized.startsWith("/superadmin/website-builder")) {
    return "/superadmin/website-builder"
  }
  if (normalized.startsWith("/superadmin/tenants")) return "/superadmin/tenants"
  if (normalized.startsWith("/superadmin/roles")) return "/superadmin/roles"
  if (
    normalized === "/superadmin/users/deleted-users" ||
    normalized.startsWith("/superadmin/users/deleted-users/")
  ) {
    return "/superadmin/users/deleted-users"
  }
  if (normalized.startsWith("/superadmin/users")) return "/superadmin/users"
  if (normalized.startsWith("/superadmin/countries")) {
    return "/superadmin/countries"
  }
  return "/superadmin/dashboard"
}

/** @deprecated Use resolveSuperAdminMenuPath — kept for horizontal nav top-level section. */
export function getSuperAdminActiveNavHref(pathname) {
  const menuPath = resolveSuperAdminMenuPath(pathname)
  if (
    menuPath === "/superadmin/users/deleted-users" ||
    menuPath === "/superadmin/users"
  ) {
    return "/superadmin/users"
  }
  return menuPath
}

export const SUPERADMIN_NAV_LINKS = [
  {
    path: "/superadmin/dashboard",
    icon: "bx bx-home-circle",
    titleKey: "Dashboard",
    permission: { categoryId: 101, permissionId: "sa_dashboard_1" },
  },
  {
    path: "/superadmin/roles",
    icon: "bx bx-briefcase",
    titleKey: "Roles Management",
    permission: { categoryId: 102, permissionId: "sa_roles_1" },
  },
  {
    path: "/superadmin/users",
    icon: "bx bx-user",
    titleKey: "User Management",
    permission: { categoryId: 103, permissionId: "sa_users_1" },
    children: [
      {
        path: "/superadmin/users",
        titleKey: "Users",
        permission: { categoryId: 103, permissionId: "sa_users_1" },
      },
      {
        path: "/superadmin/users/deleted-users",
        titleKey: "Deleted Users",
        permission: { categoryId: 103, permissionId: "sa_users_5" },
      },
    ],
  },
  {
    path: "/superadmin/tenants",
    icon: "bx bx-buildings",
    titleKey: "Tenants",
    permission: { categoryId: 104, permissionId: "sa_tenants_1" },
  },
  {
    path: "/superadmin/website-builder",
    icon: "bx bx-globe",
    titleKey: "Website Builder",
    permission: { categoryId: 109, permissionId: "sa_website_builder_1" },
  },
  {
    path: "/superadmin/plans",
    icon: "bx bx-package",
    titleKey: "Plans",
    permission: { categoryId: 105, permissionId: "sa_plans_1" },
  },
  {
    path: "/superadmin/billing/subscriptions",
    icon: "bx bx-receipt",
    titleKey: "All Subscriptions",
    permission: { categoryId: 106, permissionId: "sa_billing_1" },
  },
  {
    path: "/superadmin/billing/invoices",
    icon: "bx bx-file",
    titleKey: "All Invoices",
    permission: { categoryId: 106, permissionId: "sa_billing_1" },
  },
  {
    path: "/superadmin/integrations",
    icon: "bx bx-plug",
    titleKey: "Integrations",
    permission: { categoryId: 107, permissionId: "sa_integrations_1" },
  },
  {
    path: "/superadmin/countries",
    icon: "bx bx-globe",
    titleKey: "Countries",
    permission: { categoryId: 104, permissionId: "sa_tenants_1" },
  },
]
